"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiS3URL = instanceOfApiS3URL;
exports.ApiS3URLFromJSON = ApiS3URLFromJSON;
exports.ApiS3URLFromJSONTyped = ApiS3URLFromJSONTyped;
exports.ApiS3URLToJSON = ApiS3URLToJSON;
exports.ApiS3URLToJSONTyped = ApiS3URLToJSONTyped;
/**
 * Check if a given object implements the ApiS3URL interface.
 */
function instanceOfApiS3URL(value) {
    if (!('key' in value) || value['key'] === undefined)
        return false;
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
function ApiS3URLFromJSON(json) {
    return ApiS3URLFromJSONTyped(json, false);
}
function ApiS3URLFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'key': json['key'],
        'url': json['url'],
    };
}
function ApiS3URLToJSON(json) {
    return ApiS3URLToJSONTyped(json, false);
}
function ApiS3URLToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'key': value['key'],
        'url': value['url'],
    };
}
